/**
 * Copyright (C) Mairistem
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 *
 * Proprietary and confidential
 */

import _ from 'lodash';
import React from 'react';

import { Button, Modal, Icon, Grid } from '@mairistem/composants';

import { useTrimestreStore } from '@/zustand';

interface ModalWarnTrimestreActifProps {
  onClose: () => void;
  assistant?: boolean;
}

const ModalWarnTrimestreActif = (props: ModalWarnTrimestreActifProps) => {
  const { assistant = false, onClose } = props;

  const trimestre = useTrimestreStore((state) => state.trimestre);
  const { annee, periode } = trimestre;

  let trimestreTexte = _.toString(periode);
  const anneeTexte = annee;
  if (periode === 1) {
    trimestreTexte = '1er';
  } else {
    trimestreTexte = `${periode}ème`;
  }

  return (
    <Modal
      open
      size="small"
      closeOnDimmerClick
      closeOnDocumentClick
      closeOnEscape
      onClose={onClose}
      data-testid="modal-warn-trimestre-actif"
    >
      <Modal.Header>Attention au trimestre actif</Modal.Header>
      <Modal.Content>
        <Grid>
          <Grid.Row style={{ alignItems: 'center' }}>
            <Grid.Column width={3}>
              <Icon size="massive" name="warning sign" />
            </Grid.Column>
            <Grid.Column width={1} />

            <Grid.Column width={12}>
              <div>
                {assistant && (
                  <p>
                    Attention : le trimestre actuel ne correspond pas au
                    trimestre en cours de traitement.
                    <br />
                    <br />
                    Pensez à vérifier le trimestre sur lequel vous recensez
                    votre jeune.
                  </p>
                )}
                {!assistant && (
                  <p>
                    Le {trimestreTexte} trimestre {anneeTexte} est maintenant
                    terminé.
                    <br />
                    <br />
                    N&apos;oubliez pas de transférer le fichier PECOTO
                    correspondant avant de le clôturer.
                  </p>
                )}
              </div>
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </Modal.Content>
      <Modal.Actions>
        <Button
          data-testid="modal-close-warn-trimestre-actif"
          basic
          size="tiny"
          icon="cancel"
          content="Fermer"
          onClick={onClose}
        />
      </Modal.Actions>
    </Modal>
  );
};

export default ModalWarnTrimestreActif;
